import { DEFAULT_INTERNAL_TOOLS_SETTINGS } from '@repo/internal-tools-app-lib/src/constants/internalToolsAppSettings.ts'
import type { SettingsConfig } from '@repo/internal-tools-app-lib/src/lib/settingStore/settingsConfigSchema.ts'
import { createUseSettingItemValueHook } from '@repo/internal-tools-app-lib/src/lib/settingStore/useSettingItemValue.ts'

export const MAIN_APP_SETTINGS = {
  settingsId: 'ccc-main-app',
  sections: {
    appearance: DEFAULT_INTERNAL_TOOLS_SETTINGS.sections.appearance,
    featureFlags: {
      items: {
        'featureFlags.chat.enableNewChatVendor': {
          description: 'Enable the new chat vendor.',
          type: 'boolean',
          default: false,
        },
        'featureFlags.chat.enableUpload': {
          description: 'Enable chat upload',
          type: 'boolean',
          default: false,
        },
        'featureFlags.bank.enableBankPageV2': {
          description: 'Enable the new bank page with multi-bank support.',
          type: 'boolean',
          default: true,
        },
        'featureFlags.earnings.enableEarningsInsight': {
          description: 'Enable the Earnings insight (Experiment) tile.',
          type: 'boolean',
          default: false,
        },
        'featureFlags.userOverview.enableAppView': {
          description: 'Enable experimental App view feature.',
          type: 'boolean',
          default: false,
        },
        'featureFlags.card.enableCardPageV2': {
          description: 'Enable the new Card V2 page (renamed to Live Pay).',
          type: 'boolean',
          default: true,
        },
        'featureFlags.subscription.enableSubscription': {
          description: 'Enable the Subscription page and related features.',
          type: 'boolean',
          default: true,
        },
        'featureFlags.earlyPay.enableReenroll': {
          description: 'Enable the Early Pay re-enrollment button.',
          type: 'boolean',
          default: false,
        },
        'featureFlags.earnInPayroll.enableDiagnostics': {
          description:
            'Show the EarnIn Payroll diagnostics link in the Payroll status tile.',
          type: 'boolean',
          default: false,
        },
        ...DEFAULT_INTERNAL_TOOLS_SETTINGS.sections.featureFlags.items,
      },
    },
  },
} as const satisfies SettingsConfig

export const useMainAppSettingItemValue =
  createUseSettingItemValueHook(MAIN_APP_SETTINGS)
